(() => {
  var GIFT_VARIANT_ID = 54618814284044;
  var GIFT_HANDLE = "caderno-norm-x-inusitado-edicao-one-day-or-day-one";
  var THRESHOLD_CENTS = 7500;

  // Campanha: 1 Jan 00:00 → 8 Jan 23:59 (hora do browser)
  var START = new Date(2026, 0, 1, 0, 0, 0);
  var END   = new Date(2026, 0, 8, 23, 59, 59);

  var running = false;

  function isActive() {
    var n = new Date();
    return n >= START && n <= END;
  }

  function getCart() {
    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); });
  }

  function updateGiftQty(qty) {
    var body = { updates: {} };
    body.updates[GIFT_VARIANT_ID] = qty;

    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify(body),
    });
  }

  function addGift() {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: GIFT_VARIANT_ID, quantity: 1 }),
    });
  }

  // ----------------------------
  // Drawer refresh (robusto)
  // ----------------------------
  // Estas são "keys" possíveis para o HTML do drawer via sections endpoint.
  // No teu tema pode ser uma delas. Pedimos todas e usamos a primeira válida.
  var DRAWER_SECTION_KEYS = [
    "cart-drawer",
    "cart_drawer",
    "cart-drawer-section",
    "cart-drawer-content",
    "cart-drawer-template",
    "mini-cart",
    "mini_cart"
  ];

  function fetchSections(keys) {
    var url = "/?sections=" + encodeURIComponent(keys.join(",")) + "&ts=" + Date.now();
    return fetch(url, { credentials: "same-origin" })
      .then(function (r) { return r.json(); });
  }

  function pickFirstHtml(sections) {
    for (var i = 0; i < DRAWER_SECTION_KEYS.length; i++) {
      var k = DRAWER_SECTION_KEYS[i];
      if (sections && sections[k] && typeof sections[k] === "string" && sections[k].trim().length) {
        return { key: k, html: sections[k] };
      }
    }
    return null;
  }

  function refreshDrawer() {
    // Também tentamos atualizar o bubble (se existir essa section)
    var keys = DRAWER_SECTION_KEYS.concat(["cart-icon-bubble", "cart_icon_bubble"]);

    return fetchSections(keys).then(function (sections) {
      // Bubble/contador
      if (sections["cart-icon-bubble"]) {
        var bubble = document.querySelector("#cart-icon-bubble");
        if (bubble) bubble.outerHTML = sections["cart-icon-bubble"];
      } else if (sections["cart_icon_bubble"]) {
        var bubble2 = document.querySelector("#cart-icon-bubble");
        if (bubble2) bubble2.outerHTML = sections["cart_icon_bubble"];
      }

      // Drawer HTML
      var picked = pickFirstHtml(sections);
      if (!picked) return;

      var parser = new DOMParser();
      var doc = parser.parseFromString(picked.html, "text/html");

      // 1) Se existir wrapper shopify-section-cart-drawer (ou parecido), substitui o nó inteiro
      var newSection =
        doc.querySelector("#shopify-section-cart-drawer") ||
        doc.querySelector('[id*="shopify-section-cart-drawer"]') ||
        doc.querySelector('[id*="shopify-section-mini-cart"]') ||
        doc.querySelector('[id*="shopify-section-cart_drawer"]');

      var currentSection =
        document.querySelector("#shopify-section-cart-drawer") ||
        document.querySelector('[id*="shopify-section-cart-drawer"]') ||
        document.querySelector('[id*="shopify-section-mini-cart"]') ||
        document.querySelector('[id*="shopify-section-cart_drawer"]');

      if (newSection && currentSection) {
        currentSection.replaceWith(newSection);
      } else {
        // 2) fallback: atualiza o container do drawer
        var drawer =
          document.querySelector("#CartDrawer") ||
          document.querySelector("cart-drawer") ||
          document.querySelector("[data-cart-drawer]") ||
          document.querySelector(".cart-drawer");

        if (drawer) {
          // tenta usar o root do novo HTML, se existir
          var newDrawerRoot =
            doc.querySelector("#CartDrawer") ||
            doc.querySelector("cart-drawer") ||
            doc.querySelector("[data-cart-drawer]") ||
            doc.querySelector(".cart-drawer");

          drawer.innerHTML = (newDrawerRoot ? newDrawerRoot.innerHTML : doc.body.innerHTML);
        }
      }

      // Eventos (não faz mal se ninguém ouvir)
      document.dispatchEvent(new CustomEvent("cart:updated"));
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    }).catch(function(){});
  }

  // ----------------------------
  // Bloquear qty no drawer + cart page
  // ----------------------------
  function unique(arr) {
    return Array.from(new Set(arr)).filter(Boolean);
  }

  function findGiftRows() {
    var rows = [];

    // drawer costuma ter variant=
    document.querySelectorAll('a[href*="variant=' + GIFT_VARIANT_ID + '"]').forEach(function (a) {
      var row = a.closest(".cart-item, .cart__item, .drawer__item, .cart-drawer__item, li, tr");
      if (row) rows.push(row);
    });

    // cart page costuma ter /products/handle
    document.querySelectorAll('a[href*="/products/' + GIFT_HANDLE + '"]').forEach(function (a) {
      var row = a.closest(".cart-item, .cart__item, .drawer__item, .cart-drawer__item, li, tr");
      if (row) rows.push(row);
    });

    return unique(rows);
  }

  function lockRow(row) {
    row.querySelectorAll('input[type="number"], input[name*="updates"]').forEach(function (inp) {
      inp.value = "1";
      inp.setAttribute("min", "1");
      inp.setAttribute("max", "1");
      inp.readOnly = true;
      inp.disabled = true;
      inp.style.pointerEvents = "none";
      inp.style.opacity = "0.6";
    });

    row.querySelectorAll(
      'button, a[href*="/cart/change"], a[href*="quantity="], button[name="plus"], button[name="minus"]'
    ).forEach(function (b) {
      b.disabled = true;
      b.setAttribute("aria-disabled", "true");
      b.style.pointerEvents = "none";
      b.style.opacity = "0.5";
    });
  }

  function lockQtyUI() {
    findGiftRows().forEach(lockRow);
  }

  // Interceta submit do carrinho (cart page POST normal)
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.action || form.action.indexOf("/cart") === -1) return;

    // força inputs do gift a 1 antes do POST
    findGiftRows().forEach(function (row) {
      row.querySelectorAll('input[type="number"], input[name*="updates"]').forEach(function (inp) {
        inp.value = "1";
      });
    });
  }, true);

  // ----------------------------
  // Regra principal
  // ----------------------------
  function enforce() {
    if (running) return;
    running = true;

    return getCart()
      .then(function (cart) {
        var gift = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].variant_id === GIFT_VARIANT_ID) { gift = cart.items[i]; break; }
        }

        // total elegível (depois de descontos) sem contar gift
        var giftValue = gift ? gift.final_line_price : 0;
        var eligible = cart.total_price - giftValue;

        var didChange = false;
        var p = Promise.resolve();

        // Fora da campanha: remove sempre
        if (!isActive()) {
          if (gift) {
            p = p.then(function(){ return updateGiftQty(0); })
                 .then(function(){ didChange = true; });
          }
          return p.then(function(){
            return didChange ? refreshDrawer() : null;
          }).then(function(){
            lockQtyUI();
          });
        }

        // clamp qty=1 (sempre)
        if (gift && gift.quantity !== 1) {
          p = p.then(function(){ return updateGiftQty(1); })
               .then(function(){ didChange = true; });
        }

        // adiciona / remove conforme patamar
        if (eligible >= THRESHOLD_CENTS && !gift) {
          p = p.then(function(){ return addGift(); })
               .then(function(){ didChange = true; });
        }

        if (eligible < THRESHOLD_CENTS && gift) {
          p = p.then(function(){ return updateGiftQty(0); })
               .then(function(){ didChange = true; });
        }

        return p.then(function(){
          // 🔥 se mudou, refresca drawer imediatamente
          return didChange ? refreshDrawer() : null;
        }).then(function(){
          lockQtyUI();
        });
      })
      .catch(function(){})
      .finally(function(){ running = false; });
  }

  // Apanha updates via fetch (drawer)
  var origFetch = window.fetch;
  window.fetch = function () {
    var res = origFetch.apply(this, arguments);
    try {
      var url = String(arguments[0] && arguments[0].url ? arguments[0].url : arguments[0]);
      if (url.indexOf("/cart/") !== -1) {
        res.finally(function(){ setTimeout(enforce, 250); });
      }
    } catch(e) {}
    return res;
  };

  document.addEventListener("DOMContentLoaded", function () {
    enforce();
    setTimeout(lockQtyUI, 600);
    // mantém lock mesmo se o tema re-renderizar
    setInterval(lockQtyUI, 1200);
  });
})();
